<template>
    <rkm-modal
        hide-header
        persistent
        ref="RkmModal"
    >
        <rkm-row>
            <rkm-col>
                <table class="table table-striped">
                    <tbody>
                    <tr>
                        <td><strong>Unidade:</strong> </td>
                        <td>{{jornada.unidadeNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Local de atendimento:</strong></td>
                        <td>{{jornada.infraestruturaNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Prestador:</strong></td>
                        <td>{{jornada.prestadorNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Grupo de exame:</strong></td>
                        <td>{{jornada.exameNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Data:</strong></td>
                        <td>{{ this.jornada.data}}</td>
                    </tr>
                    <tr>
                        <td><strong>Dia da semana:</strong></td>
                        <td>{{jornada.diasSemana}}</td>
                    </tr>
                    <tr>
                        <td><strong>Hora inicial:</strong></td>
                        <td>{{jornada.horaInicial}}</td>
                    </tr>
                    <tr>
                        <td><strong>Hora final:</strong></td>
                        <td>{{jornada.horaFim}}</td>
                    </tr>
                    <tr>
                        <td><strong>Status:</strong></td>
                        <td>{{jornada.statusNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Tipo de jornada:</strong></td>
                        <td>{{jornada.tipoNome}}</td>
                    </tr>
                    <tr>
                        <td><strong>Vagas:</strong></td>
                        <td>{{jornada.vagas}}</td>
                    </tr>
                    <tr>
                        <td><strong>Tempo de atendimento:</strong></td>
                        <td v-if="jornada.tempoAtendimento === null || jornada.tempoAtendimento === '' || jornada.tempoAtendimento == 0 ">
                            Não informado
                        </td>
                        <td v-else>
                            {{jornada.tempoAtendimento}} minutos
                        </td>
                    </tr>
                    </tbody>
                </table>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Mixins.
import { error, repository, data } from '@/mixins'

export default {
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada')
        }
    },
    data: () => ({
        items: [],
        jornada: {
            data: null,
            exameId: null,
            jornadaId: null,
            exameNome: '',
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            diasSemana:null,
            semanaId: null,
            statusId: null,
            statusNome: '',
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            unidadeNome: '',
            usuarioId: '',
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
        },
    }),
    methods: {
        open(item) {

            const formataData = this.getFormatedDate(item.data, 'DD/MM/YYYY')

            if(item.semanaId == '1'){
                this.jornada.diasSemana = 'DOMINGO'

            } else if (item.semanaId == '2'){
                this.jornada.diasSemana = 'SEGUNDA-FEIRA'

            } else if (item.semanaId == '3'){
                this.jornada.diasSemana = 'TERÇA-FEIRA'

            } else if (item.semanaId == '4'){
                this.jornada.diasSemana = 'QUARTA-FEIRA'

            } else if (item.semanaId == '5'){
                this.jornada.diasSemana = 'QUINTA-FEIRA'

            } else if (item.semanaId == '6'){
                this.jornada.diasSemana = 'SEXTA-FEIRA'

            } else if (item.semanaId == '7'){
                this.jornada.diasSemana = 'SÁBADO'
            }

            this.jornada.unidadeNome = item.unidadeNome
            this.jornada.infraestruturaNome = item.infraestruturaNome
            this.jornada.exameNome = item.exameNome
            this.jornada.data = formataData
            this.jornada.horaInicial = item.horaInicial
            this.jornada.horaFim = item.horaFim
            this.jornada.statusNome = item.statusNome
            this.jornada.tipoNome = item.tipoNome
            this.jornada.vagas = item.vagas
            this.jornada.tempoAtendimento = item.tempoAtendimento
            this.jornada.prestadorId = item.prestadorId
            this.jornada.prestadorNome = item.prestadorNome
            this.jornada.jornadaId = item.jornadaId

            this.items = []
            this.$refs.RkmModal.show()
        },
    },
    mixins: [ error, repository, data ],
}
</script>

